const { h, render, Component } = require('preact');
const Web2018Helper = require('../../../helper')

class ExpiryDate extends Component {
  constructor(props) {
    super(props);
    this.getExpiryDate = this.getExpiryDate.bind(this);
  }

  getExpiryDate(orderDetails){
    if(orderDetails && orderDetails.groupons && orderDetails.groupons[0] && orderDetails.groupons[0].expiresAtFormattedStr)
      return orderDetails.groupons[0].expiresAtFormattedStr;
    return null;
  }

  render() {
    let expiryDate = this.getExpiryDate(this.props.orderDetails);
    if (expiryDate){
      return (
        <tr>
          <td>{I18n.translate("js.modules.web_2018.expires")}:</td>
          <td>{Web2018Helper.getDateStringWithDay(expiryDate)}</td>
        </tr>
      );
    }
    return null;
  }
}
module.exports = ExpiryDate
